import i18next from 'i18next';
import React from 'react';

import { ProgressCircle } from '@commons/ProgressCircle';

import { TotalRowContainer, TotalLabelCell, TotalCircleCell } from '../styledComponents';

export const TotalRow = ({ columns, totalsByLanguage, minWidth }) => (
  <TotalRowContainer minWidth={minWidth}>
    {columns.reduce((acc, column) => {
      if (column.hidden) {
        return acc;
      }
      if (column.propertyKey === 'label') {
        return [
          ...acc,
          <TotalLabelCell key={column.id} minWidth={column.minWidth}>
            {i18next.t('GENERAL.TOTAL')}
          </TotalLabelCell>,
        ];
      }

      return [
        ...acc,
        <TotalCircleCell key={column.id} minWidth={column.minWidth}>
          <ProgressCircle percentage={totalsByLanguage[column.propertyKey] ?? 0} />
        </TotalCircleCell>,
      ];
    }, [])}
  </TotalRowContainer>
);
